var $c533d5539737c688$exports = {};
$c533d5539737c688$exports = {
    "more": `\u{411}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432}`
};


export {$c533d5539737c688$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
